import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const thumbnail: CSSObject = {
  width: 56,
  height: 56,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: color.grey600,
  borderRadius: radius.md,
  overflow: 'hidden',
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
};

const emptyThumbnail: CSSObject = {
  ...thumbnail,
  color: color.white,
  fontSize: 11,
};

const itemNo: CSSObject = {
  fontFamily: 'monospace',
  fontSize: 13,
  color: color.grey600,
  whiteSpace: 'nowrap',
};

const guide: CSSObject = {
  textAlign: 'left',
  maxWidth: 320,
  whiteSpace: 'pre-wrap',
  wordBreak: 'keep-all',
  overflowWrap: 'anywhere',
  color: color.grey700,
};

const holderCount: CSSObject = {
  textDecoration: 'underline',
  textUnderlineOffset: 3,
  fontWeight: 600,
  cursor: 'pointer',
};

const actions: CSSObject = {
  display: 'flex',
  gap: 4,
  justifyContent: 'center',
};

export { thumbnail, emptyThumbnail, itemNo, guide, holderCount, actions };
